import events from '../events';
import {max} from '../lang/number';
import {animated} from './execution';

let
    handled = false,
    width = 0,
    height = 0;

const
    publisher = events('updated'),
    publish = publisher.publish,
    screenSubscribe = publisher.subscribe,

    update = () => {
        const element = document.documentElement;

        width = max(element.clientWidth, window.innerWidth || 0);
        height = max(element.clientHeight, window.innerHeight || 0);
    },

    screenWidth = () => width,

    screenHeight = () => height;

update();
window.addEventListener('resize', () => {
    if (!handled) {
        handled = true;
        animated(() => {
            handled = false;
            update();
            publish.updated({width, height});
        });
    }
});

export {
    screenSubscribe,
    screenWidth,
    screenHeight
};
